module.exports = __webpack_public_path__ + "static/img/goods.c34e24bc.png";